import { I18n } from '@calendly/i18n';
import { SelectField } from '@calendly/ui/form/select-field';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "w16fylik";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const SelectorWrapper = ({
  indent,
  children
}) => indent ? <Wrapper>{children}</Wrapper> : children;
export const PermissionSelector = ({
  value,
  onChange,
  indent
}) => <SelectorWrapper indent={indent}>
    <SelectField label={I18n.t('publisher.event_types.filters.titles.permission')} value={value} options={[{
    id: 'editor',
    name: I18n.t('publisher.event_types.edit_hosts_modal.permissions.editor')
  }, {
    id: 'viewer',
    name: I18n.t('publisher.event_types.edit_hosts_modal.permissions.viewer')
  }]} placeholder={I18n.t('publisher.event_types.filters.select_placeholder')} onChange={onChange} />
  </SelectorWrapper>;

require("./permission_selector.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./permission_selector.js");